angular.module("angular-transfer-box", [
  "transfer/transfer.html",
  "transfer/transfer-list.html",
  "transfer/transfer-operation.html",
]),
  angular.module("angular-transfer-box").directive("transferList", function () {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            items: '=',
            showSearch : '=',
            title: '@',
            searchPlaceholder : '@',
            disabledTarget: "=",
            notFoundContent : '@',
            render: '&'
        },

        templateUrl: 'transfer/transfer-list.html',

        link: function (scope,elem) {

            if (!angular.isArray(scope.items)) {
                throw Error('Transfer List need a data list.');
            }

            scope.render = scope.render();
            scope.selectAllChecked = false;
            /**
             *  Control the render of data item
             */
            scope.innerRender = function (dataItem) {
                if (angular.isFunction(scope.render)) {
                    return scope.render(dataItem.item);
                }
                return dataItem.item;
            };

            scope.selectAll = function (selected) {
                selected = selected || false;
                scope.items.forEach(function (dataItem) {
                    if (scope.disabledTarget && scope.disabledTarget.indexOf(dataItem.item.key) !== -1) {
                      dataItem.selected = false;
                    } else if (!scope.searchContent) {
                      dataItem.selected = selected;
                    } else if (scope.searchContent && scope.innerRender(dataItem).toLowerCase().indexOf(scope.searchContent.toLowerCase()) !== -1) {
                      dataItem.selected = selected;
                    }
                });
            };

            scope.toggleItem = function (item) {
                item.selected = !item.selected;
            };

            scope.headerCheck = function () {
              var validItems = getValidItems();
              var state = scope.getCheckedNumber() < validItems.length;
              scope.selectAll(state);
            };

            function getValidItems() {
              var validItems = scope.items.filter(function (item) {
                if (scope.disabledTarget) {
                  if (scope.disabledTarget.indexOf(item.item.key) === -1) {
                    return true;
                  }
                  return false;
                } else if (scope.searchContent) {
                  return scope.searchContent && scope.innerRender(item).toLowerCase().indexOf(scope.searchContent.toLowerCase()) !== -1;
                } else {
                  return true;
                }
              });
              return validItems;
            }
          
            scope.getHeaderState = function(){
              var checkedNumber = scope.getCheckedNumber();
              scope.selectAllChecked = checkedNumber !== 0 && checkedNumber == getValidItems().length;
              return checkedNumber === 0 ? "unchecked" :
                    (checkedNumber == getValidItems().length ? "checked" : "indeterminate");
            };

            scope.getCheckedNumber = function () {
                var items = getValidItems();
                return items.reduce(function (pv, cv) {
                    return cv.selected ? (pv + 1) : pv;
                }, 0);
            };

            scope.showCheckBox = function (dataItem) {
              return !scope.disabledTarget || (scope.disabledTarget.indexOf(dataItem.item.key) === -1);
            }
          
            function updateNotFound(){
                scope.showNotFound = !scope.items.some(function(dataItem){
                    return showItem(dataItem);
                });
            }

            function updateItems(){
                scope.items.forEach(function(item){
                    item.show = showItem(item);
                });

            }

            function showItem(dataItem){
                var searchString = scope.searchContent;
                return !searchString || scope.innerRender(dataItem).toLowerCase().indexOf(searchString.toLowerCase()) !== -1;
            }

            scope.$watch('items',updateNotFound,true);

            scope.clearSearch = function(){
                scope.searchContent = '';
                angular.element(elem).find('.transfer-list-search').val(scope.searchContent);
                updateItems();
            };

            scope.searchKeyUp = function($evt){
                scope.searchContent = angular.element($evt.target).val();
                updateItems();
            };

            scope.showClear = function () {
              return scope.searchContent && scope.searchContent.length;
            }

            scope.orderBy = function (data) {
              return _.orderBy(data, 'item.key');
            }
          scope.getSelectedCount = function () {
              return scope.items.reduce(function (pv, cv) {
                return cv.selected && (!scope.disabledTarget || scope.disabledTarget.indexOf(cv.key) === -1) ? (pv + 1) : pv;
              }, 0);
          }
        }
    };
  }),
  angular
    .module("angular-transfer-box")
    .directive("transferOperation", function () {
      return {
        restrict: "E",
        replace: !0,
        scope: { change: "&", disabled: "=" },
        templateUrl: "transfer/transfer-operation.html",
      };
    }),
  angular.module("angular-transfer-box").directive("transfer", [
    "$timeout",
    function (e) {
      return {
        restrict: "E",
        replace: !0,
        scope: { originSource: "=", targetKeys: "=", option: "=", restricted: "=" },
        templateUrl: "transfer/transfer.html",
        link: function (n) {
          function t(e) {
            return e.map(function (e) {
              return { selected: !1, item: e, show: !0 };
            });
          }
          function r(e) {
            return e.map(function (e) {
              return e.item;
            });
          }
          function a(n, t) {
            for (var r = [], a = n.length - 1; a >= 0; a--) {
              var o = n[a];
              o.selected && (r.push(o), n.splice(a, 1));
            }
            r.forEach(function (e) {
              (e.selected = !1), (e.highlight = !0), e.show = !0, t.unshift(e);
            }),
              s(),
              e(function () {
                r.forEach(function (e) {
                  e.highlight = !1;
                });
              }, 150);
          }
          function s() {
            for (; n.targetKeys.length > 0; ) n.targetKeys.shift();
            r(n.targetSource).forEach(function (e) {
              n.targetKeys.push(e.key);
            });
          }
          function o(e) {
            function n(e) {
              if (null === e || void 0 === e)
                throw new TypeError(
                  "Cannot convert undefined or null to object"
                );
              return Object(e);
            }
            function t(e, n, t) {
              var s = n[t];
              if (void 0 !== s && null !== s) {
                if (a.call(e, t) && (void 0 === e[t] || null === e[t]))
                  throw new TypeError(
                    "Cannot convert undefined or null to object (" + t + ")"
                  );
                a.call(e, t) && angular.isObject(s)
                  ? (e[t] = r(Object(e[t]), n[t]))
                  : (e[t] = s);
              }
            }
            function r(e, n) {
              if (e === n) return e;
              n = Object(n);
              for (var r in n) a.call(n, r) && t(e, n, r);
              return e;
            }
            var a = Object.prototype.hasOwnProperty;
            e = n(e);
            for (var s = 1; s < arguments.length; s++) r(e, arguments[s]);
            return e;
          }
          var i = {
            orientation: "horizontal",
            render: function (e) {
              return e.key;
            },
            titles: { origin: "Source List", target: "Target List" },
            showSearch: !0,
            searchPlaceholder: "Please enter your content",
            notFoundContent: "Not Found",
            classes: "",
          };
          (n.option = o({}, i, n.option)),
            (n.targetSource = []),
            (n.source = []),
            (n.disabled = { left: !1, right: !1 }),
            (n.onChange = function (e) {
              var t = null,
                r = null;
              switch (e.toLowerCase()) {
                case "source":
                  (t = n.source), (r = n.targetSource);
                  break;
                case "target":
                  (t = n.targetSource), (r = n.source);
              }
              t && r && a(t, r);
            }),
            n.$watch("originSource", function () {
              (n.targetSource = t(
                n.originSource.filter(function (e) {
                  return n.targetKeys && n.targetKeys.indexOf(e.key) !== -1;
                })
              )),
                (n.source = t(
                  n.originSource.filter(function (e) {
                    return r(n.targetSource).indexOf(e) === -1;
                  })
                ));
            }),
            n.$watch(
              "targetSource",
              function () {
                n.disabled.target = n.targetSource.every(function (e) {
                  return !e.selected;
                });
              },
              !0
            ),
            n.$watch(
              "source",
              function () {
                n.disabled.source = n.source.every(function (e) {
                  return !e.selected;
                });
              },
              !0
            );
        },
      };
    },
  ]),
  angular.module("transfer/transfer-list.html", []).run([
    "$templateCache",
    function (e) {
      e.put(
        "transfer/transfer-list.html",
        '<div class="transfer-list-container"><b ng-bind="title"></b><div class="transfer-list"><div class="transfer-list-header-search"><div class="transfer-list-search-wrapper" ng-if="showSearch"><div><input class="transfer-list-search" placeholder="Search..." ng-model="searchContent" ng-keyup="searchKeyUp($event)" /><span ng-show="showClear()" class="form-control-feedback" ng-click="clearSearch()" style="pointer-events:all;cursor:pointer;height: 40px;line-height: 40px;"><i class="fa fa-times"></i></span></div></div></div>\n   <div class="transfer-list-header">\n   <label><input ng-click="headerCheck();" ng-model="selectAllChecked" type="checkbox" ng-checked="getHeaderState() === \'checked\'")}}"><span>({{getSelectedCount()}} selected)</span></label>   \n   </div>\n   <div class="transfer-list-body">\n <ul class="transfer-list-content">\n  <li ng-repeat="listItem in orderBy(items) track by listItem.item.key" class="transfer-list-content-item" ng-class="{\'highlight\':listItem.highlight}" ng-hide="showSearch && !listItem.show">\n               <label class="transfer-checkbox" ng-class="{\'transfer-checkbox-checked\': listItem.selected && showCheckBox(listItem)}" title="{{innerRender(listItem)}}">\n <input type="checkbox" ng-click="showCheckBox(listItem) && toggleItem(listItem);" ng-checked="listItem.selected" class="transfer-list-item" ng-disabled="!showCheckBox(listItem)" ng-class="{\'disabled\': !showCheckBox(listItem)}">\n <span class="list-item" ng-class="{\'disabled\': !showCheckBox(listItem)}" ng-bind="innerRender(listItem)"></span>\n   </label>        </li>\n           <div class="transfer-list-not-found" ng-bind="notFoundContent" ng-if="showNotFound"></div>\n       </ul>\n   </div>\n</div>\n</div>\n'
      );
    },
  ]),
  angular.module("transfer/transfer-operation.html", []).run([
    "$templateCache",
    function (e) {
      e.put(
        "transfer/transfer-operation.html",
        '<div class="transfer-operation">\n<button class="button" type="button" ng-disabled="disabled.target" ng-click="change({direction:\'target\'})"><i class="fa fa-arrow-left"></i><span style="padding-left: 12px;">Hide</span></button><button class="button" type="button" ng-disabled="disabled.source" ng-click="change({direction:\'source\'})"><i class="fa fa-arrow-right"></i><span style="padding-left: 12px;">Make available</span></button>\n</div>'
      );
    },
  ]),
  angular.module("transfer/transfer.html", []).run([
    "$templateCache",
    function (e) {
      e.put(
        "transfer/transfer.html",
        '<div class="transfer {{::option.classes}} {{::option.orientation}}">\n   <transfer-list items="source" render="option.render" title="{{::option.titles.origin}}" show-search="option.showSearch" search-placeholder="{{::option.searchPlaceholder}}" not-found-content="{{::option.notFoundContent}}">\n   </transfer-list>\n   <transfer-operation change="onChange(direction)" disabled="disabled">\n   </transfer-operation>\n   <transfer-list items="targetSource" title="{{::option.titles.target}}" disabled-target="restricted" render="option.render" show-search="option.showSearch" search-placeholder="{{::option.searchPlaceholder}}" not-found-content="{{::option.notFoundContent}}">\n   </transfer-list>\n</div>\n'
      );
    },
  ]);
